var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcTestTitle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 30"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-test-title_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F3F4F8",
  d: "M15 30c8.284 0 15-6.716 15-15S23.284 0 15 0 0 6.716 0 15s6.716 15 15 15"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#84868A",
  d: "M21.276 14.263a1.14 1.14 0 0 1-.788-.325L19.051 12.5l-1.438 1.438a1.094 1.094 0 0 1-1.562 0 1.094 1.094 0 0 1 0-1.563l1.437-1.437L16.051 9.5a1.094 1.094 0 0 1 0-1.562 1.094 1.094 0 0 1 1.562 0l1.438 1.437 1.437-1.437a1.094 1.094 0 0 1 1.563 0 1.094 1.094 0 0 1 0 1.562l-1.438 1.438 1.438 1.437a1.094 1.094 0 0 1 0 1.563c-.213.212-.5.324-.788.324zM18.689 22.387A1.07 1.07 0 0 1 18 22.15l-1.85-1.475a1.123 1.123 0 0 1-.175-1.563 1.123 1.123 0 0 1 1.563-.175l1.025.825 2.625-2.912a1.12 1.12 0 0 1 1.562-.088 1.12 1.12 0 0 1 .088 1.563l-3.325 3.687a1.12 1.12 0 0 1-.825.363z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B6BAC0",
  d: "M13.15 12.05H7.977c-.613 0-1.113-.5-1.113-1.112s.5-1.113 1.113-1.113h5.175c.612 0 1.112.5 1.112 1.113 0 .612-.5 1.112-1.112 1.112M13.15 20.175H7.977c-.613 0-1.113-.5-1.113-1.112s.5-1.113 1.113-1.113h5.175c.612 0 1.112.5 1.112 1.113 0 .612-.5 1.112-1.112 1.112"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-test-title_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})))));
export default SvgIcTestTitle;